
import { prop, Vue } from "vue-class-component";

class Props {
  fill = prop<boolean>({
    default: true,
    type: Boolean
  });
}
class Filter extends Vue.with(Props) {}
export default Filter;
